import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { useSendToAgenciesFormContext } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgencies.form.context';
import { FC, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { API_POST_selectedMarketplaceCommunitiesHourlyRate } from 'requests/POST_selectedMarketplaceCommunitiesHourlyRate';
import { useAPIActions } from 'store/reducers/api/apiSlice';
import { apiDataSelector } from 'store/reducers/api/apiSelector';
import { LegacyAPIContextType } from 'types/common.types';

import { createLegacyDataContext } from 'utils/createDataContext';

interface IFetchSelectedMarketplaceCommunitiesRateData {
  rate: {
    min: number;
    max: number;
  };
  cost: {
    min: number;
    max: number;
  };
}

export const FetchSelectedMarketplaceCommunitiesRateDataContext =
  createLegacyDataContext<IFetchSelectedMarketplaceCommunitiesRateData>({
    data: { cost: '0.00' },
  } as unknown as IFetchSelectedMarketplaceCommunitiesRateData);

export const FetchSelectedMarketplaceCommunitiesRateDataProvider: FC = ({ children }) => {
  const { apiRequest } = useAPIActions();
  const { values } = useSendToAgenciesFormContext();
  const { data } = useShiftModalDataContext();
  const order = data?.order;
  const totalDuration = order?.totalDuration;
  const displayId = order?.position.displayId;

  const requestOptions = API_POST_selectedMarketplaceCommunitiesHourlyRate({
    marketplaceCommunityIds: values.selectedMarketplaceCommunities,
    positionId: displayId!,
    shiftLength: totalDuration!,
  });

  const result = useSelector((state) => apiDataSelector(state, requestOptions));

  const defaultResult = { data: { cost: '0.00' } } as unknown as typeof result;

  useEffect(() => {
    if (values.selectedMarketplaceCommunities.length) apiRequest(requestOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.selectedMarketplaceCommunities]);

  const contextValue = values.selectedMarketplaceCommunities.length ? result : defaultResult;

  return (
    <FetchSelectedMarketplaceCommunitiesRateDataContext.Provider value={contextValue}>
      {children}
    </FetchSelectedMarketplaceCommunitiesRateDataContext.Provider>
  );
};

export const useFetchSelectedMarketplaceCommunitiesRateDataContext =
  (): LegacyAPIContextType<IFetchSelectedMarketplaceCommunitiesRateData> =>
    useContext(FetchSelectedMarketplaceCommunitiesRateDataContext);
